function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/* eslint complexity: ["error", 7] */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormInput } from '@homeaway/react-form-components';
import { createTextMaskInputElement } from 'text-mask-core';
import classNames from 'classnames';
import "./PhoneField.css";

var noop = function noop() {};

var PhoneField = /*#__PURE__*/function (_Component) {
  _inheritsLoose(PhoneField, _Component);

  function PhoneField(props) {
    var _this;

    _this = _Component.call(this, props) || this; // initially set to 1 so that the if statement in this.handleChange will run, and we can safely assume that the length of the longest mask will be greater than 0

    _this.handleChange = function (e) {
      var userInput = _this.rawUserInput(_this.telField.input.value); // the 'or' here handles the case where a user uses the browser's autofill feature to populate their phone number


      if (userInput.length <= _this.maskMaxCount || userInput && !_this.props.phoneNumber) {
        _this.updateMask(e, true);
      } else {
        _this.textMaskInput.update(userInput, _this.textMaskConfig);
      }
    };

    _this.handleFocus = function (e) {
      _this.props.onFocus(e, _this.getPhoneObject());
    };

    _this.handleBlur = function (e) {
      _this.props.onBlur(e, _this.getPhoneObject());
    };

    _this.isNumberKey = function (e) {
      return e.which >= 48 && e.which <= 57 || e.which >= 96 && e.which <= 105;
    };

    _this.isAllowedNonNumericKey = function (e) {
      var isArrow = e.which >= 37 && e.which <= 40;
      var isTabOrDelete = e.which === 8 || e.which === 9 || e.which === 127 || e.which === 46;
      return isArrow || isTabOrDelete;
    };

    _this.isAllowedCombination = function (e) {
      var isCtrl = !!(e.ctrlKey || e.metaKey);
      var isSelectAll = isCtrl && e.which === 65;
      var isCopy = isCtrl && e.which === 67;
      var isPaste = isCtrl && e.which === 86;
      var isCut = isCtrl && e.which === 88;
      var isUndo = isCtrl && e.which === 90;
      var isRedo = isCtrl && e.which === 89;
      return isSelectAll || isCopy || isPaste || isCut || isUndo || isRedo;
    };

    _this.handleNonNumericalInput = function (e) {
      if (e === void 0) {
        e = {};
      }

      if (!_this.isNumberKey(e) && !_this.isAllowedNonNumericKey(e) && !_this.isAllowedCombination(e)) {
        e.preventDefault();
      }
    };

    _this.setTelFieldRef = function (ref) {
      _this.telField = ref;
    };

    _this.maskMaxCount = 1;
    return _this;
  }

  var _proto = PhoneField.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.initTextMask();
  } // eslint-disable-next-line camelcase
  ;

  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    var currentValue = this.telField && this.telField.input.value ? this.rawUserInput(this.telField.input.value) : '';

    if (nextProps.phoneNumber !== currentValue) {
      this.textMaskConfig.mask = this.findMasks(nextProps.masks, nextProps.phoneNumber);
      this.textMaskInput.update(nextProps.phoneNumber, this.textMaskConfig);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.phoneCode !== this.props.phoneCode) {
      this.updateMask();
    }
  } // polyfill for Array.prototype.find()

  /* eslint-disable consistent-return */
  ;

  _proto.find = function find(array, predicate, context) {
    context = context || this;
    var length = array.length;
    var i;

    for (i = 0; i < length; i++) {
      if (predicate.call(context, array[i], i, array)) {
        return array[i];
      }
    }
  }
  /* eslint-enable */
  ;

  _proto.findMasks = function findMasks(maskArray, userInput) {
    var userInputLength = userInput.length; // Determine how many input places the user can actually fill in
    // (i.e. all # or digit places minus formatting characters)
    // then sort by length of user input places.

    var sortedArray = maskArray.map(function (mask) {
      var charArray = mask.split('');
      var count = 0;
      charArray.forEach(function (char) {
        if (char === '#' || /\d/.test(char)) {
          count++;
        }
      });
      return {
        mask: mask,
        count: count
      };
    }).sort(function (a, b) {
      return a.count - b.count;
    }); // sets the length of the longest mask to check against later to prevent bug where user can input one more number than should be allowed

    this.maskMaxCount = sortedArray[sortedArray.length - 1].count; // if any of the masks have fixed numbers in them and the user DOESN'T
    // start with those numbers, those masks come out of play
    // checks to make sure the fixed digit is not equal to the beginning of
    // the user input && the user has actually started putting in numbers

    var containsFixedDigits = sortedArray.some(function (obj) {
      return /\d/.test(obj.mask);
    }); // if at least one of the masks contains fixed digits and the user has
    // started typing

    if (containsFixedDigits && userInput.length) {
      // then sort through them all
      sortedArray.forEach(function (obj, i) {
        // if this particular mask contains a digit but doesnt match the
        // users input
        if (/\d/.test(obj.mask) && obj.mask[obj.mask.search(/\d/)] !== userInput[0]) {
          // splice it out of the available options
          sortedArray.splice(i, 1);
        }
      });
    }

    var selectedMask = this.find(sortedArray, function (mask) {
      return mask.count >= userInputLength;
    }) || sortedArray[sortedArray.length - 1];
    return this.createInputMask(selectedMask.mask);
  }
  /** Can be called to externally focus the proper input component. */
  ;

  _proto.focus = function focus() {
    this.telField.focus();
  };

  _proto.createInputMask = function createInputMask(mask) {
    var maskCharArray = mask.split('');
    var formattedMask = []; // eslint-disable-next-line

    maskCharArray.forEach(function (char) {
      if (char === '#' || /\d/.test(char)) {
        formattedMask.push(/\d/);
      }

      if (char === ' ' || char === '(' || char === ')' || char === '-' || char === '.') {
        formattedMask.push(char);
      }
    });
    return formattedMask;
  };

  _proto.initTextMask = function initTextMask() {
    this.textMaskConfig = {
      inputElement: this.telField.input,
      placeholderChar: '_',
      guide: true,
      showMask: false
    };
    this.textMaskInput = createTextMaskInputElement(this.textMaskConfig);
    this.updateMask();
  };

  _proto.rawUserInput = function rawUserInput(userInput) {
    if (userInput === void 0) {
      userInput = '';
    }

    return userInput.split('').filter(function (c) {
      return /\d/.test(c);
    }).join('');
  }
  /**
   * Generates an object containing the current state of the phone field.
   * @returns {{raw: string, formatted: string, phoneCode: string, isValid: boolean}}
   *  An object describing current state: raw is the unformatted phone number,
   *  formatted is the formatted version, phoneCode is the phone country code
   *  (e.g. '+1'), and isValid is true if the number is valid.
   */
  ;

  _proto.getPhoneObject = function getPhoneObject() {
    return {
      raw: this.rawUserInput(this.telField && this.telField.input.value),
      formatted: this.telField && this.telField.input.value,
      phoneCode: this.props.phoneCode,
      isValid: this.isPhoneNumberValid()
    };
  };

  _proto.updateMask = function updateMask(e, allowEmpty) {
    if (e === void 0) {
      e = {};
    }

    var value = this.telField && (this.telField.input.value || allowEmpty) ? this.telField.input.value : this.props.phoneNumber;
    var userInput = this.rawUserInput(value);

    if (value) {
      this.textMaskConfig.mask = this.findMasks(this.props.masks, userInput);
      this.textMaskInput.update(userInput, this.textMaskConfig);
    }

    this.props.onChange(e, this.getPhoneObject());
  };

  _proto.isPhoneNumberValid = function isPhoneNumberValid() {
    return !/_/.test(this.telField.input.value);
  };

  _proto.render = function render() {
    var _classNames;

    var _this$props = this.props,
        id = _this$props.id,
        labels = _this$props.labels,
        phoneCode = _this$props.phoneCode,
        showCountrySelect = _this$props.showCountrySelect,
        phoneNumber = _this$props.phoneNumber,
        errorMsg = _this$props.errorMsg,
        helpText = _this$props.helpText;
    var inputClassName = classNames((_classNames = {}, _classNames["react-input-tel__country-code-" + phoneCode.length] = true, _classNames['react-input-tel__phone-field'] = true, _classNames['show-dropdown'] = showCountrySelect, _classNames['not-empty'] = phoneNumber || this.telField && this.telField.input.value, _classNames));
    return /*#__PURE__*/React.createElement("div", {
      role: "presentation",
      className: "input-group-wrapper",
      onKeyDown: this.handleNonNumericalInput
    }, /*#__PURE__*/React.createElement(FormInput, {
      ref: this.setTelFieldRef,
      id: id,
      "data-wdio": "input-tel__phone-field__input",
      className: inputClassName,
      leftContent: !showCountrySelect ? "+" + phoneCode : null,
      label: labels.phoneNumber,
      errorMsg: errorMsg,
      onChange: this.handleChange,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      type: "tel",
      autoComplete: "tel",
      helpText: helpText
    }));
  };

  return PhoneField;
}(Component);

PhoneField.propTypes = {
  masks: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  phoneCode: PropTypes.string,
  phoneNumber: PropTypes.string,
  errorMsg: PropTypes.string,
  helpText: PropTypes.string
};
PhoneField.defaultProps = {
  labels: {},
  masks: [],
  onChange: noop,
  onFocus: noop,
  onBlur: noop,
  phoneCode: '1',
  phoneNumber: ''
};
export default PhoneField;
//# sourceMappingURL=PhoneField.js.map